export const getProductUrl = (message: string) => {
  const regex = /Add( the)? <a href="(https:\/\/www\.johnlewis\.com\/[^\s"]+)"/;
  const match = message.match(regex);

  const integrationRegex =
    /(https:\/\/www\.integration\.project4\.com\/[^\s"]+)"/;
  const integrationMatch = message.match(integrationRegex);

  const productUrl = match
    ? match[2]
    : integrationMatch
      ? integrationMatch[1]
      : null;
  return productUrl;
};

export const getSecondProductUrl = (message: string) => {
  const regex =
    /Add( the)? <a href="(https:\/\/www\.johnlewis\.com\/[^\s"]+)"/g;
  const matches = Array.from(message.matchAll(regex));

  const integrationRegex =
    /Add( the)? <a href="(https:\/\/www\.integration\.project4\.com\/[^\s"]+)"/g;
  const integrationMatches = Array.from(message.matchAll(integrationRegex));

  if (matches.length >= 2 && matches[1]) {
    return matches[1][2];
  }

  if (integrationMatches.length >= 2 && integrationMatches[1]) {
    return integrationMatches[1][2];
  }
  return null;
};

export const getProductId = (productUrl: string) => {
  const match = productUrl.match(/\/p(\d+)/);
  const productId = match ? match[1] : null;
  return productId;
};

export const getGwpPercentage = (
  gwpSpentTotal: number,
  gwpTargetTotal: number,
) => {
  let percentage = 0;

  if (gwpSpentTotal >= gwpTargetTotal) {
    percentage = 100;
  } else {
    percentage = (gwpSpentTotal / gwpTargetTotal) * 100;
  }

  return percentage;
};

export const getGWPTotal = (messageTitle: string) => {
  const regex = /when you spend £(\d*)\s/;
  const match = messageTitle.match(regex);
  const gwpTotal = match ? Number(match[1]) : null;
  return gwpTotal;
};

export const getGwpPromotionBrand = (messageTitle: string) => {
  const regex = /\bon (.*) \(/;
  const match = messageTitle.match(regex);
  const gwpBrand = match ? match[1] : null;
  return gwpBrand;
};

export const getMoneyOffAmount = (messageTitle: string) => {
  const regex = /Save £(.*) when you spend/;
  const match = messageTitle.match(regex);
  const moneyOffAmount = match ? match[1] : null;
  return moneyOffAmount;
};

export const getTargetProductId = (
  description: string | undefined,
): string | null | undefined => {
  const giftProductUrl = description ? getProductUrl(description) : null;
  const productId = giftProductUrl ? getProductId(giftProductUrl) : null;
  return productId;
};

export const getSecondTargetProductId = (
  description: string | undefined,
): string | null | undefined => {
  const giftProductUrl = description ? getSecondProductUrl(description) : null;
  const productId = giftProductUrl ? getProductId(giftProductUrl) : null;
  return productId;
};
